import Repository from './Repository'
import TokenService from '../helpers/token'
const resource = `${Repository.defaults.baseURL}/chatbot`
export default {
  //miss call
  async missCall(body) {
    const response = await Repository.post(`${resource}/miss-call`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  }
}
